import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, CardMedia } from '@mui/material';
import { useLocation, useParams } from 'react-router';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import {
  Layout,
  Loading,
  Navbar,
  ReturnButton,
  SMSNotificationButton,
} from '../../../../components';
import * as EventActions from '../../../../core/events/action';
import * as VendorEventsActions from '../../../../core/vendor-events/action';
import { VENUE_NAVBAR_MENU, VENDOR_NAVBAR_MENU } from '../../../../constants/navbar';
import AboutYourEvent from './components/AboutYourEvent';
import CheckOutButtons from './components/CheckOutButtons';
import AboutYourVenue from './components/AboutYourVenue';
import CheckIcon from './components/CheckIcon';
import PointOfContact from './components/PointOfContact';
import VenueButton from '../../../../components/Messenger/ChatButton/VenueButton';
import ModalNotificationSMS from '../../dashboard/venues-dashboard/components/ModalNotification/ModalNotificationSMS';
import SpaceDimension from './components/SpaceDimension';
import { VENUE_FEATURES } from '../../../../constants/venue';
import DefaultPhoto from '../../../../assets/img/default-img.png';
import { useStorageImage } from '../../../../hooks/useStorageImage';
import Map from './components/Map';
import { APPLICATION_STATUS } from '../../../../constants/event-application-status';

export default function EventDetail() {
  const [title] = useState('Event Details');
  const {
    events: { event, loading, displayModalSMS, urlData },
    venues: { venueDetails },
    vendorEvents: { currentVendorEvent, loading: vendorEventsLoading },
  } = useSelector((store) => store);
  const location = useLocation();
  // console.log('Current URL:', location.pathname);
  const { eventId } = useParams();
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.users);
  const [seeDigitalMarketing, setSeeDigitalMarketing] = useState(false);
  const CustomizedSwal = withReactContent(Swal);

  const image = useStorageImage(event?.photo);

  useEffect(() => {
    dispatch(EventActions.getEventById(eventId, user?.role.name));
    dispatch(VendorEventsActions.findVendorEventRegistered(user?.id, eventId));
  }, [dispatch, eventId, user?.role.name, user?.id]);

  useEffect(() => {
    setSeeDigitalMarketing(false);
    if (user?.role?.id === 5 || user?.role?.id === 2) {
      setSeeDigitalMarketing(true);
    } else if (user?.role?.id === 1) {
      if (currentVendorEvent?.application_status === APPLICATION_STATUS.APPROVED)
        setSeeDigitalMarketing(true);
    } else {
      setSeeDigitalMarketing(false);
    }
  }, [event, currentVendorEvent, user?.role?.id]);

  useEffect(() => {
    if (event?.parameters_event?.digital_marketing) {
      dispatch(EventActions.getDigitalMarketing(event?.id));
    }
  }, [event?.parameters_event?.digital_marketing, dispatch, event?.id]);

  const getVeneFeatureFree = () => {
    const iconList = [];
    if (venueDetails?.length <= 0) return [];

    venueDetails?.link_venue_features.forEach((fe) => {
      const wanted = VENUE_FEATURES.find((i) => i.id === fe.fk_feature);
      if (wanted) iconList.push(wanted);
    });
    return iconList;
  };

  const onSendMessage = (message) => {
    if (!message) return;
    dispatch(EventActions.sendNotificationSMSToVendors(message, eventId));
  };

  const onCloseModalSMS = () => {
    dispatch(EventActions.onDisplayModalSMS(false));
  };

  const onDisplayModalSMS = () => {
    dispatch(EventActions.onDisplayModalSMS(true));
  };

  const onDisableClicked = () => {
    CustomizedSwal.fire({
      title: 'Warning',
      icon: 'warning',
      text: `Are you sure you want to disable event ${event.name}?`,
      showCancelButton: true,
      confirmButtonText: 'Disable',
    }).then(({ isConfirmed }) => {
      if (!isConfirmed) return;
      dispatch(EventActions.disableEvent(event.id));
    });
  };

  return (
    <Layout>
      {loading && <Loading />}
      <Navbar
        elements={user?.role?.name === 'Fayven-Vendor' ? VENDOR_NAVBAR_MENU : VENUE_NAVBAR_MENU}
      />
      <Grid container justifyContent="space-evenly">
        <Typography variant="h4" fontWeight="bold" marginTop={9}>
          {title}
        </Typography>
      </Grid>

      <Grid container justifyContent="flex-start" marginTop={2}>
        <Grid item md={2} marginLeft={{ md: 20 }}>
          <ReturnButton />
        </Grid>
      </Grid>

      <Grid container justifyContent="center" marginTop={2}>
        <Grid item xs={12} md={10}>
          <Typography variant="h6" paddingX={4} textAlign="center">
            A collection of resources to help you navigate the venue & help you make the most out of
            your event!
          </Typography>
        </Grid>
      </Grid>

      <Grid container marginTop={5} justifyContent="center">
        <Grid
          item
          sm={11}
          backgroundColor="#e2bcaf2e"
          borderRadius="45px"
          paddingX={{ xs: 5, md: 5, xl: 20 }}
          paddingBottom={3}
          marginBottom={3}
          marginX={{ xs: 1, xl: 20 }}
          justifyContent="space-evenly">
          <div>
            <Typography
              variant="h5"
              color="#EE7B57"
              marginTop={4}
              textAlign="center"
              fontWeight="bold"
              style={{ textTransform: 'uppercase' }}>
              {event?.name}
            </Typography>
          </div>
          <Grid container justifyContent="space-between" marginTop={1}>
            <Grid item xs={12} sm={6} md={6} lg={5} borderRadius="15px">
              <CardMedia
                component="img"
                height="350"
                style={{ borderRadius: '20px' }}
                image={image || DefaultPhoto}
                alt=""
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <AboutYourEvent
                event={event}
                venue={venueDetails}
                freeFeatures={getVeneFeatureFree()}
                registeredAttendees={53}
                vendors={27}
                foodTrucks={3}
                seeDigitalMarketing={seeDigitalMarketing}
              />
              <CheckOutButtons
                eventId={eventId}
                role={user?.role?.name}
                onDisableClicked={onDisableClicked}
              />
            </Grid>
            <Grid container marginY={3}>
              <SpaceDimension spaceDimensions={event?.space_dimensions} />
            </Grid>
            <Grid container marginY={3}>
              <AboutYourVenue
                event={event}
                venue={venueDetails}
                surcharges={event?.surcharges}
                freeFeatures={getVeneFeatureFree()}
              />
            </Grid>
            <Grid container>
              <PointOfContact venue={venueDetails} event={event} />
            </Grid>
            <Grid container marginY={3}>
              <Map city={event?.city} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {displayModalSMS && (
        <ModalNotificationSMS
          open={displayModalSMS}
          event={event}
          title="Notification Vendors"
          handleClose={onCloseModalSMS}
          onSave={onSendMessage}
        />
      )}

      <VenueButton venue={event?.venue} />
      <SMSNotificationButton onClick={() => onDisplayModalSMS()} />
    </Layout>
  );
}
